//import Vue from 'vue';
import { ethics, innovation, riskReduction, services, strategy, trust } from './icons';
import { ethics as ethicsJPG, innovation as innovationJPG, riskReduction as riskJPG, services as servicesJPG, strategy as strategyJPG, trust as trustJPG } from './pictures';

export const components = {
    ethics, 
    innovation, 
    riskReduction, 
    services, 
    strategy, 
    trust
}

export default [ {
        title: 'Strategy',
        text: 'Business, Change, Project, Transition and Transformation',
        component: 'strategy',
        image: strategyJPG
    }, {
        title: 'Services',
        text: 'Managed, Hosted, Cloud, Contracted, Ad-Hoc.',
        component: 'services',
        image: servicesJPG
    }, {
        title: 'Ethics',
        text: 'We are committed to keeping your data secure, and carrying out your objectives in a respectful and ethical manor.',
        component: 'ethics',
        image: ethicsJPG
    }, {
        title: 'Innovation',
        text: 'Always attuned to your needs to maximise the return on your investment',
        component: 'innovation',
        image: innovationJPG
    }, {
        title: 'Trust',
        text: "We deliver the best results for today's challenges and tomorrow's opportunities.",
        component: 'trust',
        image: trustJPG
    }, {
        title: 'Risk Reduction',
        text: "Insurance, Reliability, Qualifications, Quality.",
        component: 'riskReduction',
        image: riskJPG
    }
]